// Same wording as the legacy Resubscribe screen (routes/Account/Subscription/Resubscribe).
export const RESUBSCRIBE_ERROR_TITLE = 'Oops! Something went wrong...'

export const RESUBSCRIBE_DAY_CONFLICT_ERROR_MESSAGE =
  "Delivery cut-off time has passed which means your slot isn't available anymore. Please select another day"

export const RESUBSCRIBE_GENERIC_ERROR_MESSAGE =
  "We're really sorry, but it seems there's an unexpected issue on our end: we're currently unable to update your subscription."
